import {
  Button,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { InfoIcon } from '@tonic-one/react-icons';
import { useTranslation } from 'react-i18next';
import { PolicySubTypeEnum } from '@Types/index';
import { PolicyListModalName, PolicyListModalState } from '../../utils/types';

export default function GmailPolicyEnableModal({
  modal,
  setModal,
}: {
  modal: PolicyListModalState;
  setModal: ({ name, policy }: PolicyListModalState) => void;
  setRefreshTableTrigger: (trigger: Date) => void;
}) {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation('policy');

  if (modal.name !== PolicyListModalName.GmailNote) {
    return <></>;
  }
  const onClose = () => {
    setModal({
      name: PolicyListModalName.None,
      policy: null,
    });
  };

  let desc = '';
  switch (modal.policy.policySubType) {
    case PolicySubTypeEnum.inbound:
      desc = t('policy.modals.gmailEnable.inbound.desc');
      break;
    case PolicySubTypeEnum.outbound:
      desc = t('policy.modals.gmailEnable.outbound.desc');
      break;
    default:
      desc = '';
  }

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={true}
      onClose={onClose}
      size="md"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent>
        <ModalHeader>{t('policy.modals.gmailEnable.title')}</ModalHeader>
        <ModalBody>
          <Flex alignItems="top" gap="8px">
            <Icon as={InfoIcon} color={colorStyle.color.info} />
            <Text>{t('policy.modals.gmailEnable.note')}</Text>
          </Flex>
          <Text
            dangerouslySetInnerHTML={{
              __html: desc,
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" minWidth="20x" onClick={onClose}>
            {t('common.button.ok')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
